module.exports = __webpack_public_path__ + "img/11.951c254e.jpg";